import { useEffect, useRef } from 'react';
import { VAGARO_WIDGET_SRC } from '../config';

// Reproduces Vagaro's embed snippet. Their loader script scans for the
// `.vagaro` / `#frameTitle` containers and injects the booking iframe into them.
// The snippet assumes a fresh page load, so in this SPA we inject the script on
// mount and remove it (plus anything Vagaro rendered) on unmount, so navigating
// away and back re-initializes cleanly.
export default function VagaroWidget() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = VAGARO_WIDGET_SRC;
    container.appendChild(script);

    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      // Remove any iframe/nodes Vagaro's loader injected so a remount starts fresh.
      container.querySelectorAll('iframe').forEach((node) => node.remove());
    };
  }, []);

  return (
    <>
      <div id="frameTitle" className="embedded-widget-title" />
      <div
        className="vagaro"
        ref={containerRef}
        style={{ width: 250, padding: 0, border: 0, margin: '0 auto', textAlign: 'center' }}
      >
        <a href="https://www.vagaro.com/pro/">Powered by Vagaro</a>{' '}
        <a href="https://www.vagaro.com/pro/salon-software">Salon Software</a>,{' '}
        <a href="https://www.vagaro.com/pro/spa-software">Spa Software</a>{' & '}
        <a href="https://www.vagaro.com/pro/fitness-software">Fitness Software</a>
      </div>
    </>
  );
}
